/**
 * 在线巡检系统相关
 * 接口地址 http://rap2.10niu.cn/repository/editor?id=21&mod=630&itf=4089
 * 原型 https://qnv3kb.axshare.com/#id=noy65c&p=%E6%A0%A1%E5%9B%AD%E7%9B%B4%E6%92%AD&g=1&hi=1
 */

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';
/* 
 * 在线巡检系统
 */
const onlinePatrol = {
	// 萌萌播_批量请求摄像头生成截图
	batchCreateChannelSnapshot(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/batch_create_channel_snapshot`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 在线巡检_分组_添加
	addGroup(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/online_inspection/group/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 在线巡检_分组_列表
	getGroupList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/online_inspection/group/list`,
			headers: config.headers,
			params
		});
	},
	// 在线巡检_分组_编辑
	editGroup(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/online_inspection/group/edit`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 在线巡检_分组_删除
	delGroup(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/online_inspection/group/del`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 在线巡检_分组_设为默认
	defaultGroup(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/online_inspection/group/default`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 在线巡检_分组_按条件查询列表
	listByCondition(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/online_inspection/group/list_by_condition`,
			headers: config.headers,
			params
		});
	},
	// 在线巡检_通道_列表
	getChannelList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/online_inspection/channel/list`,
			headers: config.headers,
			params
		});
	},
	// 在线巡检_评论_列表
	getCommentList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/online_inspection/comment/list`,
			headers: config.headers,
			params
		});
	},
	// 在线巡检_评论_添加
	addComment(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/online_inspection/comment/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 在线巡检_批量拉流
	checkConnectBatch(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/check-connect-batch`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};

export default onlinePatrol;
